var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FullscreenFrontageDialog',{ref:"frontageDialog"},[[_c('CallerIdSettings',{attrs:{"show":true},on:{"goToSettings":_vm.handleSubmit,"cancel":_vm.handleClose}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }